import React from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';

import { Button } from '@nearst/ui';

import styles from './HelpButton.module.scss';

const HelpButton = ({ href, children = '' }) => {
	return (
		<Button link href={href} target="_blank" rel="noreferrer" className={styles.help}>
			<QuestionMarkCircleIcon className={styles.helpIcon} />
			{children}
		</Button>
	);
};

export default HelpButton;
